import { useState } from "react";
import { API } from "@/lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";

export default function AdminBulkImages() {
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const [report, setReport] = useState(null);

  const upload = async () => {
    if (!files.length) return toast.error("Pilih beberapa gambar dulu");
    setBusy(true);
    const fd = new FormData();
    for (const f of files) fd.append("files", f);
    const token = localStorage.getItem("admin_token");
    try {
      const r = await fetch(`${API}/admin/images/bulk`, { method: "POST", body: fd, headers: { Authorization: `Bearer ${token}` } });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || "Upload gagal");
      setReport(d);
      toast.success(`Assigned: ${d.assigned} · Unassigned: ${d.unassigned} · Rejected: ${d.rejected}`);
    } catch (e) { toast.error(e.message); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <h1 className="display text-4xl md:text-6xl">BULK IMAGE UPLOAD</h1>
        <Link to="/admin/products" className="border border-[color:var(--border)] text-neutral-400 px-6 py-3 text-xs tracking-widest">← BACK</Link>
      </div>
      <div className="border border-[color:var(--border)] p-6 space-y-4">
        <p className="text-neutral-400 text-sm">
          Gambar harus diberi nama dengan SKU. Contoh: <span className="mono">TS-001_front.jpg</span>, <span className="mono">TS-001_back.jpg</span>, <span className="mono">TS-001_detail.jpg</span>. Bila SKU tidak ditemukan, gambar masuk ke <Link to="/admin/images/unassigned" className="underline">UNASSIGNED IMAGES</Link>. Tidak ada penebakan otomatis.
        </p>
        <input data-testid="bulk-files" type="file" accept="image/*" multiple onChange={(e) => { setFiles(Array.from(e.target.files || [])); setReport(null); }} className="text-sm" />
        {files.length > 0 && <div className="text-xs text-neutral-500">{files.length} file dipilih</div>}
        <button data-testid="bulk-upload-btn" onClick={upload} disabled={busy || !files.length} className="bg-white text-black px-6 py-3 text-xs tracking-widest disabled:opacity-60">{busy ? "MENGUNGGAH..." : "UPLOAD SEMUA"}</button>
      </div>

      {report && (
        <div className="mt-6 border border-[color:var(--border)]">
          <div className="p-4 flex flex-wrap gap-3 text-sm border-b border-[color:var(--border)]">
            <span className="text-emerald-400">ASSIGNED: <strong>{report.assigned}</strong></span>
            <span className="text-amber-400">UNASSIGNED: <strong>{report.unassigned}</strong></span>
            <span className="text-[color:var(--accent)]">REJECTED: <strong>{report.rejected}</strong></span>
          </div>
          <table className="w-full text-xs">
            <thead className="text-[10px] tracking-widest text-neutral-500">
              <tr className="border-b border-[color:var(--border)]">
                <th className="p-2 text-left">FILE</th><th className="p-2 text-left">STATUS</th>
                <th className="p-2 text-left">SKU</th><th className="p-2 text-left">ROLE</th>
                <th className="p-2 text-left">DETAIL</th>
              </tr>
            </thead>
            <tbody>
              {report.results.map((r, i) => (
                <tr key={i} className={`border-b border-[color:var(--border)] ${r.status === "unassigned" ? "bg-amber-950/20" : r.status === "rejected" ? "bg-red-950/30" : ""}`}>
                  <td className="p-2 mono">{r.filename}</td>
                  <td className="p-2 uppercase">{r.status}</td>
                  <td className="p-2 mono">{r.sku || r.detected_sku || "—"}</td>
                  <td className="p-2 mono">{r.role || "—"}</td>
                  <td className="p-2 text-neutral-500">{r.reason || r.storage_path || ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
